import _styled from '@emotion/styled/base';
import { BADGE_VARIANT } from './constants.js';
import { Spacing } from '../primitives/spacing.js';
import { shorthandSpacingCss } from '../primitives/Spacer/index.js';
import { border } from '@hubble/tokens/web';

const STATUS_THEME_MAP = {
  info: 'informational',
  success: 'positive',
  warning: 'warning',
  alert: 'negative',
  neutral: 'neutral',
  reward: 'reward'
};
function getBackgroundColor({
  status,
  variant,
  theme
}) {
  if (status) {
    if (variant === BADGE_VARIANT.counter) {
      return theme.colorScheme.status.bold.background[STATUS_THEME_MAP[status]];
    }
    if (variant === BADGE_VARIANT.pip) {
      return theme.colorScheme.status.default.content[STATUS_THEME_MAP[status]];
    }
    return theme.colorScheme.status.default.background[STATUS_THEME_MAP[status]];
  }
}
function getContentColor({
  status,
  variant,
  theme
}) {
  if (status) {
    if (variant === 'counter') {
      return theme.colorScheme.status.bold.content[STATUS_THEME_MAP[status]];
    }
    return theme.colorScheme.status.default.content[STATUS_THEME_MAP[status]];
  }
}
function getPadding({
  size,
  variant
}) {
  if (variant === 'pip') return 0;
  if (variant === 'counter') return size === 'xs' ? `0 ${Spacing.scale[0.5]}` : `${Spacing.scale[0.25]} ${Spacing.scale[1]}`;
  return size === 'sm' ? `${Spacing.scale[0.25]} ${Spacing.scale[1]}` : `${Spacing.scale[0.5]} ${Spacing.scale[1]}`;
}
function getBorderRadius(variant) {
  if (variant === 'counter' || variant === 'pip') return border.radius.full;
  return border.radius.sm;
}
const BaseBadge = _styled("span", {
  target: "e77rnxe0"
})("align-items:center;background-color:", p => getBackgroundColor(p), ";border-radius:", ({
  variant
}) => getBorderRadius(variant), ";display:inline-flex;justify-content:center;padding:", p => getPadding(p), ";", ({
  bordered,
  theme
}) => bordered && `border: 2px solid ${theme.colorScheme.background.primary};`, " ", ({
  variant
}) => variant === 'pip' && `
    padding: ${Spacing.scale[0.5]};
  `, " ", shorthandSpacingCss, " ", ({
  size,
  variant
}) => variant === 'counter' && size === 'xs' && `min-width: 16px;`, " ", ({
  isSingleCounterDigit,
  size,
  variant
}) => variant === 'counter' && size !== 'xs' && isSingleCounterDigit && `max-width: 20px;`, " strong{color:", p => getContentColor(p), ";", ({
  variant
}) => variant === 'counter' && `font-feature-settings: "tnum" on, "lnum" on;`, " ", ({
  size,
  variant
}) => variant === 'counter' && size === 'xs' && `font-size: 9px;`, ";}svg{fill:", p => getContentColor(p), ";height:", Spacing.scale[2], ";width:", Spacing.scale[2], ";}");

export { BaseBadge };
